import { Link } from '@inertiajs/react'
import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { useBasePath } from '@/lib/paths'
import { Pagination, PaginationMeta } from '@/components/shared/Pagination'
import { InboundEmailSummary, BusinessRef } from '@/types'
import { Mail, ArrowRight } from 'lucide-react'

type Props = {
  business: BusinessRef
  inbound_emails: InboundEmailSummary[]
  pagination: PaginationMeta
}

export default function BusinessInboundEmailsIndex({ business, inbound_emails, pagination }: Props) {
  const basePath = useBasePath()

  return (
    <DashboardLayout
      title={`Emails — ${business.name}`}
      breadcrumbs={[
        { label: 'Businesses', href: 'businesses' },
        { label: business.name, href: `businesses/${business.id}` },
        { label: 'Emails' },
      ]}
    >
      <div className="space-y-4">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <Mail className="w-4 h-4 text-muted-foreground" />
            <h1 className="text-xl font-semibold tracking-tight">Emails</h1>
          </div>
          <p className="text-sm text-muted-foreground font-mono">{business.email}</p>
        </div>

        <section className="border rounded-lg">
          {inbound_emails.length > 0 ? (
            <div>
              {inbound_emails.map((email, i) => (
                <Link
                  key={email.id}
                  href={`${basePath}/businesses/${business.id}/inbound_emails/${email.id}`}
                  className={`flex items-center justify-between px-4 py-3 hover:bg-muted/50 transition-colors ${i > 0 ? 'border-t' : ''}`}
                >
                  <div className="min-w-0 flex-1">
                    <div className="text-sm font-medium text-foreground truncate">
                      {email.subject || '(no subject)'}
                    </div>
                    <div className="text-xs text-muted-foreground">
                      From: {email.from_address} · {new Date(email.created_at).toLocaleDateString()}
                    </div>
                  </div>
                  <ArrowRight className="w-4 h-4 text-muted-foreground shrink-0 ml-3" />
                </Link>
              ))}
            </div>
          ) : (
            <div className="px-4 py-6 text-center text-sm text-muted-foreground">
              No emails yet
            </div>
          )}
        </section>

        <Pagination pagination={pagination} />
      </div>
    </DashboardLayout>
  )
}
